import { useState } from "react";
import type { MailOutboxFilters, MailOutboxItem } from "@/lib/notification.api";
import type { MailOutboxPageFilters } from "../mailOutboxPage.types";

const INITIAL_FILTERS: MailOutboxPageFilters = {
  status: undefined,
  templateKey: undefined,
  recipient: "",
  from: "",
  to: "",
};

export function useMailOutboxPageState() {
  const [filters, setFilters] = useState<MailOutboxPageFilters>(INITIAL_FILTERS);
  const [page, setPage] = useState(1);
  const [detailItem, setDetailItem] = useState<MailOutboxItem | null>(null);

  function updateFilters(nextFilters: Partial<MailOutboxPageFilters>) {
    setFilters((current) => ({ ...current, ...nextFilters }));
    setPage(1);
  }

  function resetFilters() {
    setFilters(INITIAL_FILTERS);
    setPage(1);
  }

  const apiFilters: MailOutboxFilters = {
    status: filters.status,
    templateKey: filters.templateKey,
    recipient: filters.recipient || undefined,
    from: filters.from || undefined,
    to: filters.to || undefined,
  };

  return {
    filters,
    apiFilters,
    page,
    setPage,
    detailItem,
    setDetailItem,
    updateFilters,
    resetFilters,
  };
}
